import axios, { AxiosResponse } from 'axios';
import { OrderFormRow } from '../components/shared/OrderForm';
// Do not handle any errors here. Leave it for the caller.

const uri = '/sv-se/api/ShoppingCartApi/shoppingcart';
const placeUri = '/sv-se/api/ShoppingCartApi/place';
const clearUri = '/sv-se/api/ShoppingCartApi/shoppingcartdelete';
const baseUri = '/sv-se/api/ShoppingCartApi';

export interface SubmitResponse {
  created: boolean,
  message: string,
}

// Represents an order item
export interface AddToCartRequestItem {
  catalogEntryCode?: string;
  includeInOrder: boolean;
  quantity?: number;
  reference?: string;
  selectedDistributorShortName?: string;
}

// Represents price details for a product
export interface CartItemPrice {
  distributorLink: string | null;
  distributorName: string;
  distributorShortName: string;
  isSellable: boolean;
  price: number;
  stockBalance: number;
  stockStatus: string;
  stockStatusDescription: string;
}

// Represents an item in the cart response
export interface CartItemResponse {
  author: string;
  cartItemId: number;
  catalogEntryCode: string;
  coverUrl: string;
  distributorId: number;
  includeInOrder: boolean;
  itemUrl: string;
  market: string;
  prices: CartItemPrice[];
  quantity: number;
  reference: string;
  selectedPrice: number;
  selectedPriceShortName: string;
  title: string;
}

export const getCart = async () => await axios.get(uri);

export const getArticleInfo = async (catalogEntryCode: string | undefined): Promise<OrderFormRow> => {
  const { data } = await axios.get(`${baseUri}/article/${catalogEntryCode}`);

  return data;
};

export const addItemsToCart = async (items: AddToCartRequestItem[]): Promise<CartItemResponse[]> => {
  const response = await axios.post(uri, items, {
    headers: {
      "content-type": "application/json"
    }
  });

  return response?.data as CartItemResponse[];
};

export const addItem = async (item: AddToCartRequestItem) => await axios.post(uri, [item]);

export const removeItem = async (id: number) => await axios.delete(uri + `/${id}`);

export const clearCart = async () => await axios.delete(clearUri);

export const updateCart = async (cart: any): Promise<AxiosResponse<any, any>> => {
  return await axios.put(uri, cart, {
    headers: {
      "Content-Type": "application/json",
    }
  });
}

export const saveOrder = async (cart: any, reference: string): Promise<SubmitResponse> => await axios
  .post<SubmitResponse>(placeUri, { items: cart, reference })
  .then(response => response.data)
